module.exports = __webpack_public_path__ + "img/penta_edged_sword.a310b5f0.png";